import type { PrescriptionT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { PATIENT_RX_ORDERS_TAB_ID } from '@/features/patient-workspace/model/tabIds';
import { getRowKeyFromOptionalId, toTableSearchText } from '@/shared/lib/table';

import type { PatientGlobalSearchHit } from '../types';

function parseDateMs(value: unknown): number | null {
  if (typeof value !== 'string' || value.trim() === '') {
    return null;
  }
  const next = new Date(value).getTime();
  return Number.isFinite(next) ? next : null;
}

export function toPrescriptionSearchHits(
  prescriptions: readonly PrescriptionT[]
): PatientGlobalSearchHit[] {
  return prescriptions.map((prescription, index) => {
    const resultId = getRowKeyFromOptionalId(prescription.PrescriptionId, index, 'prescription');
    const title = toTableSearchText(prescription.DisplayName).trim() || 'Prescription';
    const status = toTableSearchText(prescription.Status).trim();
    const writtenDate = toTableSearchText(prescription.WrittenDate).trim();
    const subtitleParts = ['DoseSpot prescription', status, writtenDate].filter(
      (part) => part !== ''
    );
    const keywords = [
      prescription.DisplayName,
      prescription.Status,
      prescription.MedicationStatus,
      prescription.WrittenDate,
      prescription.EffectiveDate,
      prescription.Quantity,
      prescription.Refills,
    ]
      .map(toTableSearchText)
      .join(' ')
      .trim();

    return {
      id: `rx:prescriptions:${resultId}`,
      resource: 'rx:prescriptions',
      tabId: PATIENT_RX_ORDERS_TAB_ID,
      title,
      subtitle: subtitleParts.join(' · '),
      keywords,
      sortTimestampMs: parseDateMs(prescription.WrittenDate),
      resultId,
    };
  });
}
